import styled from 'styled-components';
import { InfoTooltip } from '@upright/ui/common/generic/components/tooltip';
import { INPUT_GUIDANCE } from '../input-guidance';

/**
 * "Revenue or %" column header with its guidance tooltip (PLT-7027), shared by the Hierarchy and
 * list views. The design-system `InfoTooltip` portals its overlay, so the table can't clip it, and
 * opens on hover and keyboard focus (same pattern as the site locations table).
 */
export function RevenueColumnHeader() {
  return (
    <HeaderWithTooltip>
      Revenue or %
      <InfoTooltip size="small" text={INPUT_GUIDANCE.revenue} />
    </HeaderWithTooltip>
  );
}

const HeaderWithTooltip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--space__xs);
  white-space: nowrap;
`;
